import axios from 'axios/index'

const namespaced = true

const state = {
  categoriesList: null,
  categoryTypes: null,
  serverTypes: null
}
const getters = {}
const actions = {
  getServerTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v3.0/server-type/'
      })
        .then(response => {
          commit('setServerTypes', response.data.reverse())
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  categoriesList ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v3.0/categories/'
      })
        .then(response => {
          commit('setCategoriesList', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createCategory ({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v3.0/categories/',
        data: data
      }).then(response => {
        dispatch('categoriesList')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  editCategory ({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v3.0/categories/' + data.id + '/',
        data: data.form
      })
        .then(() => {
          dispatch('categoriesList')
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteCategory ({ state }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'DELETE',
        url: '/api/private/v3.0/categories/' + data.id + '/'
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadCategoryTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v3.0/category-types/'
      })
        .then(response => {
          commit('setCategoryTypes', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
const mutations = {
  setCategoriesList (state, data) {
    data.forEach((obj, index) => {
      obj.index = index
    })
    state.categoriesList = data
  },
  setCategoryTypes (state, data) {
    state.categoryTypes = data
  },
  setServerTypes (state, data) {
    state.serverTypes = data
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
